import { render, staticRenderFns } from "./LegalStepper.vue?vue&type=template&id=3e5710ec&"
import script from "./LegalStepper.vue?vue&type=script&lang=js&"
export * from "./LegalStepper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports